import PageStyle from "@/styles/components/request-for-more/_index.module.scss";
import Button from "@/components/button";
import "react-datetime/css/react-datetime.css";
import moment from 'moment';
import { Field, FieldArray, Form, FormStyle, Formik, FormikControl, InputError, useTranslation, InputText } from '@/imports-files/common/common';
import { Page } from "@/imports-files/pages/clients/jobs/candidate-profile-job";
import {Yup, requestForMoreSlots, TRANSLATION, todayDate, tomorrowDate} from '@/imports-files/pages/interviews/cronofy';
import { setFilledDate } from "@/imports-files/components/job-filters";
import { setDateTimeFilledDate, isCorrectTime, isValidDate} from "@/actions/pages/clients/jobs/common";
import { FormModalStyle } from "@/imports-files/components/common-modal/common-modal";
import Modal from "@/components/common-modal/modal";


export function RequestForMoreSlot({setBtnPopup, token, status, router, setInitialData, tzid}) {
  const { t } = useTranslation();
  const type = status == 'Scheduled' ? 'reschedule_request' : 'more_slot_request'
  let date = new Date();
  date.setDate(date.getDate() + 22);
  const initialValues = {
    preferred_date: status == 'Scheduled' ? '' : date,
    preferred_time: '09:00',
    reason: ''
  }

  function validationSchema(t){
   let a = {
    preferred_date: Yup.string().nullable().required(t('errors:required'))
                      .test("is-valid-date", t('errors:invalid_preferred_date'), function(value) {
                        return isValidDate(value)
                      }),
    preferred_time: Yup.string().required(t('errors:required'))
                      .test("is-correct", t('errors:invalid_preferred_time'), function(value) {
                        return isCorrectTime(value)
                      }),
    reason: Yup.string().required(t('errors:required'))
  }
const   REQUEST_MORE_SLOT =   Yup.object(a)
return REQUEST_MORE_SLOT
}

  return (
  <Modal
    type="form"
    heading = {status == "Scheduled" ? <span>{t('modal:form:reschedule:reschedule_request')}</span> : <span>{t('modal:form:reschedule:request_more_slots')}</span>}
    closeModal={(event) => {
     setBtnPopup(false)
    }}
    content={
      <div className={`RequestMore ${FormModalStyle.Modal__Container__ContentSection} mt30`}>

        { <Formik
            initialValues={initialValues}
            validationSchema={validationSchema(t)}
            onSubmit={
              async (values) => {
                await requestForMoreSlots({values: values, router: router, setBtnPopup: setBtnPopup, token: token, type: type, setInitialData: setInitialData, tzid: tzid})
              }
            }
          >
            {(formik) => (
              <Form>
                {/* <div className={`${PageStyle.SetupPopup__ContentBlock} ${PageStyle.mt15}`}> */}
                {/*   <label>Preferred Date and Time</label> */}
                {/* </div> */}
                {/* <div className={`${PageStyle.SetupPopup__ContentBlock}`}>
                  <FormikControl
                    control         =   "customDateTime"
                    className       =   {'JobCustomDateTime'}
                    format          =   {'DD/MM/YYYY HH:mm'}
                    inputProps      =   {{
                                            placeholder: "",
                                            readOnly: true,
                                            style: InputError(formik, "preferred_date_time")
                                        }}
                    name            =   {"prefered_date_time"}
                    formik          =   {formik}
                    minDate         =   { new Date(new Date().setDate(new Date().getDate()+1)) }
                    disablePast     =   { new Date() }
                    initialValue    =   {formik.values.preferred_date_time}
                    onChange        =   {(moment) => {
                                                        formik.setFieldValue('preferred_date_time',moment.format('DD/MM/YYYY HH:mm'));
                                                     }}
                    value           =   {  typeof formik.values.preferred_date_time == 'string' ? setDateTimeFilledDate(formik.values.preferred_date_time) : formik.values.preferred_date_time}
                  />
                </div> */}
                <div className={`${PageStyle.Preferred_Date_Time}`}>
                  <div className={`${PageStyle.Preferred_Date_Time__LeftColumn} ${PageStyle.Form__TableCol}`}>
                    <label className={`${PageStyle.Form__FloatingLabel}`} style = {InputText(formik, `preferred_date`)}>
                      <span className={`red-color`}>*</span>&nbsp;{t('modal:form:reschedule:preferred_date')}</label>
                    <FormikControl
                      control         =   "customKeyboardPicker"
                      className       =   {`${PageStyle.Preferred__Date}`}
                      format          =   {'DD/MM/YYYY'}
                      inputProps      =   {{
                                            readOnly: false,
                                            style:   InputError(formik, `preferred_date`),
                                          }}
                      minDate         =   { new Date(new Date().setDate(new Date().getDate()+1)) }
                      minDateMessage  =   {`Preferred date must be present or future date`}
                      disablePast     =   { true }
                      placeholder     =   "dd/mm/yyyy"
                      name            =   {`preferred_date`}
                      onChange        =   { async (date)=> {
                                              await formik.setFieldValue(`preferred_date`, date ? date.format('DD/MM/YYYY') : '')
                                            }
                                          }
                      formik          =   {formik}
                      custom_error_90 = {"custom_error_90"}
                      custom_class    = {"form_custom_error mt0"}
                      value           =   {  typeof formik.values.preferred_date == 'string' ? setFilledDate(formik.values.preferred_date) : formik.values.preferred_date}
                    />
                  </div>
                  <div className={`${PageStyle.Preferred_Date_Time__RightColumn} ${PageStyle.Form__TableCol} Timebg Timebg-arrow-down`}>
                    <label className={`${PageStyle.Form__FloatingLabel} ${InputText(formik, 'preferred_time') ? 'errorClass' : ''}`} style = {InputText(formik, `preferred_time`)}> <span className={`red-color`}>*</span>&nbsp;{t('modal:form:reschedule:preferred_time')}</label>
                    <FormikControl
                      control      =  {"timeinput"}
                      disabled     =  {false}
                      value        =  {formik.values.preferred_time}
                      fullTimeDropdown = {true}
                      allowDelete  =  {true}
                      hour12Format =  {false}
                      onChange  = {(dateString) => {
                          formik.setFieldValue(`preferred_time`, dateString)
                        }
                      }
                      inputProps = {{
                        style:  InputError(formik, `preferred_time`),
                      }}
                      errorClass   =  {PageStyle.Form__Error}
                      name = {`preferred_time`}
                      formik = {formik}
                      manuallyDisplayDropdown={true}
                      custom_class    = {"form_custom_error"}
                    />
                  </div>
                </div>

                <div className={`${PageStyle.SetupPopup__ContentBlock} ${PageStyle.Form__TableCol} mt30`}>
                  <label className={`Dpflex ${PageStyle.Form__FloatingLabel}`} style={InputText(formik, 'reason')}>{t('modal:form:reschedule:reason')}
                    {/*<p className={`normalweight ml6`}>(Optional)</p>*/}</label>
                  <FormikControl
                    control="customtextarea"
                    type="text"
                    formik={formik}
                    name={"reason"}
                    className={`${PageStyle.Form__Textarea}`}
                    style={InputError(formik, 'reason')}
                    placeholder={t('placeholder:write_here')}
                    custom_class    = {"form_custom_error"}
                  />
                </div>

                <div className={`${FormModalStyle.Modal__Container__ButtonSection}`}>
                  <Button buttonstyle={`${PageStyle.secondarybtn}`} type="button" onClick={()=> setBtnPopup(false)}>
                  {t('button:cancel')}
                  </Button>
                  <Button buttonstyle={`${PageStyle.primarybtn}`} type="submit">{t('modal:form:reschedule:send_request')}</Button>
                </div>
              </Form>
            )
            }
          </Formik>
        }
      </div>
    }
    />
  )

}
